import withSession from "grandus-lib/utils/session";
import useWishlist from "grandus-lib/hooks/useWishlist";
import { USER_CONSTANT } from "grandus-lib/constants/SessionConstants";
import { FrownOutlined, LockOutlined, DeleteOutlined } from "@ant-design/icons";

import Link from "next/link";

import { get, isEmpty, map } from "lodash";
import { Layout, Row, Col, Table, Tag, Result, Button } from "antd";
import UserPageLayout from "components/user/UserPageLayout";

import styles from "./wishlist.page.module.scss";

import dynamic from "next/dynamic";
const AddToCartButtonWithPrice = dynamic(() =>
  import("components/cart/AddToCartButtonWithPrice")
);
const Image = dynamic(() =>
  import("grandus-lib/components-atomic/image/Image")
);
const Price = dynamic(() =>
  import("grandus-lib/components-atomic/price/Price")
);

const ItemsCount = ({ items = [] }) => {
  let count = 0;
  let text = "položiek";

  if (!isEmpty(items)) {
    count = items.length;
    switch (+count) {
      case 1:
        text = "položka";
        break;
      case 2:
      case 3:
      case 4:
        text = "položky";
        break;
    }
  }

  return (
    <small>
      ({count} {text})
    </small>
  );
};

const Wishlist = ({ user }) => {
  const { wishlist, isLoading, itemRemove } = useWishlist();

  if (!user) {
    return (
      <Layout className="container">
        <Layout.Content>
          <Result
            icon={<LockOutlined />}
            title="Iba pre prihlasených"
            subTitle="Zoznam obľúbených položiek je dostupný iba pre prihlasených používateľov. Po prihlasení, sa Váš zoznam automaticky prenáša medzi všetkými vašimi zariadeniami."
            extra={
              <Link href="/prihlasenie" as="/prihlasenie">
                <Button type="primary">Prihlásenie</Button>
              </Link>
            }
          />
        </Layout.Content>
      </Layout>
    );
  }

  const columns = [
    {
      title: "Názov",
      dataIndex: "name",
      key: "name",
      fixed: "left",
    },
    {
      title: "Dostupnosť",
      dataIndex: "avail",
      key: "avail",
      align: "center",
    },
    {
      title: "",
      dataIndex: "actions",
      key: "actions",
      align: "right",
    },
  ];
  let data = [];
  map(get(wishlist, "items", []), (item, index) => {
    if (get(item, "product.id")) {
      data.push({
        name: (
          <Link
            href="produkt/[id]"
            as={`produkt/${get(item, "product.urlTitle")}`}
          >
            <a className={styles?.link}>
              <Image
                photo={get(item, "product.photo")}
                size={"50x50"}
                type={"jpg"}
                className={styles?.photo}
              />

              <span>{get(item, "product.name")}</span>
            </a>
          </Link>
        ),
        avail: (
          <>
            {get(item, "product.isOrderable") ? (
              <Tag color="success">
                {get(item, "product.storeStatus.messageAvailable")}
              </Tag>
            ) : (
              <Tag color="error">
                {get(item, "product.storeStatus.messageUnavailable")}
              </Tag>
            )}
            <div className={styles?.priceMobile}>
              <Price
                priceData={get(item, "product.finalPriceData", {})}
                options={{ hideVatPrice: true }}
              />
            </div>
          </>
        ),
        actions: (
          <div
            className={`${styles?.actions} ${
              !item?.product?.isOrderable ? styles?.singleAction : null
            }`}
          >
            {item?.product?.isOrderable ? (
              <AddToCartButtonWithPrice
                stores={get(item, "product.store", [])}
                productId={get(item, "product.id")}
                price={
                  <Price
                    priceData={get(item, "product.finalPriceData", {})}
                    options={{ hideVatPrice: true }}
                  />
                }
                extra={
                  <Button
                    type="text"
                    danger
                    onClick={(e) =>
                      !isLoading && get(item, "product.id")
                        ? itemRemove(get(item, "product.id"))
                        : null
                    }
                  >
                    <DeleteOutlined />
                  </Button>
                }
              />
            ) : (
              <Button
                type="text"
                danger
                onClick={(e) =>
                  !isLoading && get(item, "product.id")
                    ? itemRemove(get(item, "product.id"))
                    : null
                }
              >
                <DeleteOutlined />
              </Button>
            )}
          </div>
        ),
      });
    }
  });

  return (
    <UserPageLayout
      emptyData={{
        title: "Zoznam obľúbených položiek je prázdny",
        subTitle:
          "Po vložení produktov do obľúbených položiek, sa Váš nákupný zoznam automaticky prenáša medzi všetkými vašimi zariadeniami.",
        isEmpty: !data.length,
      }}
      headerData={{
        title: "Obľúbené položky",
      }}
      breadcrumbs={[
        {
          path: "/wishlist",
          breadcrumbName: "Obľúbené položky",
        },
      ]}
    >
      <div className={`${styles?.wishlist}`}>
        <Table
          loading={isLoading}
          bordered={false}
          showHeader={false}
          pagination={false}
          columns={columns}
          dataSource={data}
          scroll={{ x: true }}
        />
      </div>
    </UserPageLayout>
  );
};

export const getServerSideProps = withSession(async function ({ req, res }) {
  const user = req.session.get(USER_CONSTANT);

  return {
    props: { user: user ? user : null },
  };
});

export default Wishlist;
